<template>
    <v-autocomplete
        ref="autocomplete"
        v-model="value"
        :items="options"
        :no-data-text="
            toSentenceCase(
                $t(
                    'planning.promotionsMaintenance.products.newProductSetupModal.noMatchingProducts'
                )
            )
        "
        :menu-props="{ auto: true }"
        density="comfortable"
        allow-overflow
    />
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
    data() {
        return {
            options: [],
            value: '',
        };
    },
    created() {
        // Format the product data for display.
        this.options = this.params.options;

        // Set initial value of autocomplete to be the existing value.
        // Look up the product to ensure the correct option is set.
        const selectedProxyProduct = this.options.find(
            proxyProduct => proxyProduct.value.productKey === this.params.data.proxyProductKey
        );

        this.value = selectedProxyProduct ? selectedProxyProduct.value : null;
    },
    mounted() {
        // Focus the input and show the menu by default to ensure the user
        // doesn't have to click multiple times within the grid cell.
        this.$nextTick(() => {
            this.$refs.autocomplete.focus();
            this.$refs.autocomplete.isMenuActive = true;
        });
    },
    methods: {
        getValue() {
            return this.value;
        },
        isPopup() {
            return false;
        },
    },
});
</script>
